var map = {
	"./2025-10-02/full.md": 76787,
	"./2025-10-15/full.md": 40791,
	"./2025-11-05/full.md": 10251,
	"./2025-11-15/full.md": 14420,
	"./2025-11-25/full.md": 17877
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18039;